import { z } from 'zod'

export const SelfAssessmentWizardSchema = z.object({
  answers: z.array(
    z
      .number()
      .nullable()
      .refine((value): value is number => value !== null, 'validationErrors.required'),
  ),
})

export type SelfAssessmentWizardFormValues = z.input<typeof SelfAssessmentWizardSchema>
